export const ObservabilityPanel = ({ observability }) => {
  const summary = observability?.system_health_overview || {
    average_request_latency_ms: observability?.metrics?.average_request_latency_ms,
    active_alerts: observability?.alerts?.total_active,
    open_circuits: (observability?.reliability?.open_circuits || []).length,
    memory_usage_mb: ((observability?.metrics?.memory_usage_trend || [])[0]?.memory_bytes || 0) / (1024 * 1024),
    risk_score: observability?.health_intelligence?.risk_score,
    status: observability?.health_intelligence?.status,
  };
  const alerts = observability?.latest_alerts || observability?.alerts?.latest || [];
  const reliability = observability?.reliability?.modules || [];
  const logItems = observability?.logs?.logs || observability?.logs || [];

  return (
    <section className="jarvis-panel jarvis-panel-span-full" data-testid="observability-panel">
      <div className="jarvis-panel-header">
        <div>
          <p className="jarvis-eyebrow">Enterprise observability</p>
          <h2 className="jarvis-title" data-testid="observability-panel-title">System Health Overview</h2>
        </div>
        <div className="jarvis-chip" data-testid="observability-panel-chip">{summary.status || "stable"}</div>
      </div>

      <div className="jarvis-observability-grid" data-testid="observability-summary-grid">
        <div className="jarvis-detail-box" data-testid="observability-latency-box">
          <span>Avg request latency</span>
          <strong>{summary.average_request_latency_ms ?? 0} ms</strong>
        </div>
        <div className="jarvis-detail-box" data-testid="observability-alert-count-box">
          <span>Active alerts</span>
          <strong>{summary.active_alerts ?? 0}</strong>
        </div>
        <div className="jarvis-detail-box" data-testid="observability-open-circuits-box">
          <span>Open circuits</span>
          <strong>{summary.open_circuits ?? 0}</strong>
        </div>
        <div className="jarvis-detail-box" data-testid="observability-memory-box">
          <span>Memory footprint</span>
          <strong>{summary.memory_usage_mb ?? 0} MB</strong>
        </div>
        <div className="jarvis-detail-box" data-testid="observability-risk-box">
          <span>Risk score</span>
          <strong>{summary.risk_score ?? 0}</strong>
        </div>
      </div>

      <div className="jarvis-log-columns" data-testid="observability-columns">
        <div className="jarvis-log-column" data-testid="observability-alerts-column">
          <h3>Alerts</h3>
          {alerts.slice(0, 6).map((alert, index) => (
            <div className={`jarvis-log-entry jarvis-alert-${alert.severity || "info"}`} key={alert.id || index} data-testid={`observability-alert-${index}`}>
              <strong>{alert.title || alert.event_type}</strong>
              <small>{alert.severity} · {alert.message}</small>
            </div>
          ))}
        </div>
        <div className="jarvis-log-column" data-testid="observability-reliability-column">
          <h3>Reliability</h3>
          {reliability.slice(0, 6).map((item, index) => (
            <div className="jarvis-log-entry" key={`${item.module}-${index}`} data-testid={`observability-reliability-${index}`}>
              <strong>{item.module}</strong>
              <small>{item.state} · failures {item.failure_count ?? 0}</small>
            </div>
          ))}
        </div>
        <div className="jarvis-log-column" data-testid="observability-logs-column">
          <h3>Structured Logs</h3>
          {logItems.slice(0, 6).map((item, index) => (
            <div className="jarvis-log-entry" key={`${item.timestamp || index}-${index}`} data-testid={`observability-log-${index}`}>
              <strong>{item.service} · {item.event_type}</strong>
              <small>{item.severity} · {item.message}</small>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};